module.exports = __webpack_public_path__ + "img/enamad.c59d02b.svg";